var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBotLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bot-face"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector-group",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1924 6.85408L13.9157 17.5668C18.4526 12.7703 24.8771 9.77777 32.0004 9.77777C39.1241 9.77777 45.5488 12.7706 50.0857 17.5675L47.8089 6.85408H16.1924ZM9.89492 4.05419L4.52275 29.333H4C1.79086 29.333 0 31.1239 0 33.333V46.6663C0 48.8755 1.79086 50.6663 4 50.6663H7.11155V53.3094C7.11155 56.9803 9.60991 60.1802 13.1712 61.0705L17.9899 62.2752C22.5719 63.4207 27.2771 64 32.0002 64C36.723 64 41.428 63.4208 46.0098 62.2754L50.8296 61.0705C54.3909 60.1801 56.8893 56.9803 56.8893 53.3093V50.6663H60C62.2091 50.6663 64 48.8755 64 46.6663V33.333C64 31.1239 62.2091 29.333 60 29.333H59.4786L54.1064 4.05419C53.6036 1.68844 51.5469 0 49.1679 0H14.8334C12.4544 0 10.3977 1.68845 9.89492 4.05419ZM21.4798 41.1045L23.994 43.6186L20.223 47.3896L23.9941 51.1608L21.48 53.675L17.7088 49.9038L13.9373 53.6753L11.4232 51.1611L15.1947 47.3896L11.4233 43.6183L13.9375 41.1042L17.7088 44.8755L21.4798 41.1045ZM50.0658 41.1048L52.58 43.619L48.8087 47.3902L52.58 51.1614L50.0658 53.6756L46.2946 49.9044L42.5233 53.6756L40.0092 51.1614L43.7804 47.3902L40.0092 43.619L42.5233 41.1048L46.2946 44.876L50.0658 41.1048ZM24.8935 55.9986H39.1158V57.7764H24.8935V55.9986Z",
    fill: "current"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotLogo);
export default __webpack_public_path__ + "static/media/bot-logo.25cf6eff.svg";
export { ForwardRef as ReactComponent };